// removed by extract-text-webpack-plugin
module.exports = {"container":"M7axNlNqPhz26oRazSU8N","fade-in":"_25gGk_8RTKK9oSM6ro0-HB"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/styles.css
// module id = 367
// module chunks = 0